module.exports = __webpack_public_path__ + "img/mobile-signal.093c5f3a.svg";